import './PageLoader.css';
export default function PageLoader() { return <div className="page-loader" role="status" aria-live="polite"><span /><span /><span /><b>Home Style</b></div>; }
